import App from './app/app';
import ReactDOM from 'react-dom';
import React from 'react';
import { initFacebookForLogin } from '../../../domain/facebook/facebook-login-provider';
import { initGoogleForLogin } from '../../../domain/google/google-login-provider';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('membership-signup-app');
    if (!$root) return;

    initFacebookForLogin();
    initGoogleForLogin(false);

    ReactDOM.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};